
import React, { useState, useEffect } from "react";
import axios from "axios";
import { resources } from "../Resourses/Resources";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  CircularProgress,
} from "@mui/material";
import { RemoveRedEyeOutlined, Close } from "@mui/icons-material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FEEDBACK_TYPES = {
  Teacher: "getTeacherFeedbackDetails",
  Student: "getstudentfeedback",
  Employee: "getEmployeeFeedBackDetails",
  Alumni: "getalumunifeedback",
};

const getTableColumns = (feedbackType) => {
  const columns = {
    Teacher: [
      { key: "name", label: "Teacher's Name" },
      { key: "email", label: "Email" },
      { key: "department", label: "Department" },
      { key: "academicyear", label: "Academic Year" },
      { key: "regulation", label: "Regulation" },
    ],
    Employee: [
      { key: "empname", label: "Employee Name" },
      { key: "designation", label: "Designation" },
      { key: "organization", label: "Organization" },
      { key: "academicyear", label: "Academic Year" },
    ],
    Alumni: [
      { key: "regno", label: "Reg No" },
      { key: "nameofalumni", label: "Name of Alumni" },
      { key: "academicyear", label: "Academic Year" },
      { key: "department", label: "Department" },
      { key: "yearofstudy", label: "Year of Study" },
    ],
    Student: [
      { key: "regno", label: "Reg No" },
      { key: "nameofstudent", label: "Student Name" },
      { key: "department", label: "Department" },
      { key: "academicyear", label: "Academic Year" },
      { key: "semester", label: "Semester" },
    ],
  };

  return columns[feedbackType] || [];
};

const ViewFeedback = () => {
  const [state, setState] = useState({
    open: false,
    feedbackData: [],
    selectedFeedback: null,
    feedbackType: "",
    isLoading: false,
    error: null,
  });

  const {
    open,
    feedbackData,
    selectedFeedback,
    feedbackType,
    isLoading,
    error,
  } = state;

  const handleViewClick = (feedback) => {
    setState((prev) => ({ ...prev, selectedFeedback: feedback, open: true }));
  };

  const handleClose = () => {
    setState((prev) => ({ ...prev, open: false, selectedFeedback: null }));
  };

  const handleTypeChange = (e) => {
    const type = e.target.value;
    setState((prev) => ({ ...prev, feedbackType: type, feedbackData: [] }));
  };

  useEffect(() => {
    const fetchFeedbackData = async () => {
      if (!feedbackType) return;

      setState((prev) => ({ ...prev, isLoading: true, error: null }));

      try {
        const endpoint = FEEDBACK_TYPES[feedbackType];
        if (!endpoint) throw new Error("Invalid feedback type");

        const { data } = await axios.get(
          `${resources.APPLICATION_URL}${endpoint}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        setState((prev) => ({
          ...prev,
          feedbackData: Array.isArray(data) ? data : [],
          isLoading: false,
        }));
      } catch (error) {
        const errorMsg =
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch data";
        setState((prev) => ({
          ...prev,
          error: errorMsg,
          isLoading: false,
        }));
        console.error("Fetch error:", error);
      }
    };

    fetchFeedbackData();
  }, [feedbackType]);

  const columns = getTableColumns(feedbackType);

  return (
    <div className="teacher_feedback_form_main_container">
      <div className="teacher_feedback_heading_container">
        <h2 className="teacher_form_heading">View Feedback Submissions</h2>
      </div>

      <div className="grevience_form_main_container">
        <div className="grevience_form_sub_container">
          <div className="grevience_inp_container">
            <label htmlFor="feedback-type">Feedback Type:</label>
            <select
              id="feedback-type"
              value={feedbackType}
              onChange={handleTypeChange}
              className="feedback-select"
            >
              <option value="">-- Select --</option>
              {Object.keys(FEEDBACK_TYPES).map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {error && <div className="error-alert">{error}</div>}

      {isLoading ? (
        <div className="loading-indicator">
          <CircularProgress />
          <span>Loading feedback data...</span>
        </div>
      ) : (
        feedbackType && (
          <div className="feedback-results">
            <table className="feedback-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  {columns.map((column) => (
                    <th key={column.key}>{column.label}</th>
                  ))}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {feedbackData.length > 0 ? (
                  feedbackData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {columns.map((column) => (
                        <td key={column.key}>{item[column.key] || "-"}</td>
                      ))}
                      <td>
                        <IconButton
                          onClick={() => handleViewClick(item)}
                          className="view-button"
                          aria-label="view"
                        >
                          <RemoveRedEyeOutlined />
                        </IconButton>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length + 2} className="no-data">
                      No feedback submissions found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )
      )}

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar position="sticky" className="detail-appbar">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <Close />
            </IconButton>
            <h3>Feedback Details</h3>
          </Toolbar>
        </AppBar>

        {selectedFeedback && (
          <div className="feedback-detail-content">
            {columns.map((column) => (
              <div key={column.key} className="detail-item">
                <span className="detail-label">{column.label}:</span>
                <span className="detail-value">
                  {selectedFeedback[column.key] || "Not available"}
                </span>
              </div>
            ))}

            {selectedFeedback.filePath && (
              <div className="file-preview">
                <h4>Attachment</h4>
                <iframe
                  src={`${resources.APPLICATION_URL}viewFile?path=${selectedFeedback.filePath}`}
                  title="Feedback attachment"
                  className="file-iframe"
                />
              </div>
            )}
          </div>
        )}
      </Dialog>

      <style jsx>{`
        .teacher_feedback_form_main_container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
        }

        .teacher_feedback_heading_container {
          background-color: #2c268a;
          width: 100%;
          border-radius: 10px;
          margin-bottom: 20px;
        }

        .teacher_form_heading {
          color: #fff;
          letter-spacing: 1px;
          font-family: Arial, Helvetica, sans-serif;
          font-size: 22px;
          text-align: center;
          padding: 10px;
        }

        .grevience_form_main_container {
          display: flex;
          width: 80%;
          justify-content: space-around;
          align-items: center;
        }

        .grevience_form_sub_container {
          background-image: linear-gradient(to right, #dbd4b4, #e1f5c4);
          padding: 20px;
          border-radius: 10px;
          width: 40%;
          display: flex;
          flex-direction: column;
          padding: 20px;
          justify-content: center;
          margin: 20px;
        }

        .grevience_inp_container {
          padding: 10px;
          width: 100%;
          display: flex;
          flex-grow: 1;
          justify-content: center;
          background-color: rgb(37, 37, 53);
          margin-top: 10px;
          align-items: center;
          text-align: center;
        }

        .grevience_inp_container label {
          color: #fff;
          margin: 10px;
          font-weight: 700;
          font-family: Arial, Helvetica, sans-serif;
          letter-spacing: 3px;
        }

        .grevience_inp_container select {
          width: 200px;
          margin-bottom: 10px;
          height: 1cm;
          border-radius: 10px;
          padding: 6px;
          border: 1px solid black;
          outline: none;
          padding-left: 25px;
        }

        .grevience_inp_container select:focus {
          border: 1px solid aqua;
        }

        .error-alert {
          padding: 12px;
          margin: 16px 0;
          background-color: #ffebee;
          color: #c62828;
          border-left: 4px solid #c62828;
          border-radius: 4px;
          width: 80%;
          text-align: center;
        }

        .loading-indicator {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          padding: 40px;
          color: #555;
          width: 100%;
        }

        .feedback-results {
          width: 90%;
          margin: 20px auto;
          overflow-x: auto;
        }

        .feedback-table {
          width: 100%;
          border-collapse: collapse;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
          border-radius: 8px;
          overflow: hidden;
        }

        .feedback-table th {
          background-color: #2c268a;
          color: white;
          padding: 12px 16px;
          text-align: left;
          font-weight: 600;
        }

        .feedback-table td {
          padding: 12px 16px;
          border-bottom: 1px solid #edf2f7;
          color: #4a5568;
        }

        .feedback-table tr:hover {
          background-color: #f8fafc;
        }

        .view-button {
          color: #4299e1;
        }

        .view-button:hover {
          background-color: #ebf8ff;
        }

        .no-data {
          text-align: center;
          padding: 20px;
          color: #718096;
          font-style: italic;
        }

        .detail-appbar {
          background-color: #2c268a;
        }

        .feedback-detail-content {
          padding: 24px;
          background-color: #f8fafc;
          min-height: 100%;
        }

        .detail-item {
          margin-bottom: 16px;
          display: flex;
          gap: 12px;
          padding: 12px;
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .detail-label {
          font-weight: 600;
          min-width: 180px;
          color: #4a5568;
        }

        .detail-value {
          color: #2d3748;
          word-break: break-word;
        }

        .file-preview {
          margin-top: 32px;
          border-top: 1px solid #e2e8f0;
          padding-top: 24px;
        }

        .file-preview h4 {
          margin-bottom: 16px;
          color: #4a5568;
        }

        .file-iframe {
          width: 100%;
          height: 500px;
          border: 1px solid #e2e8f0;
          border-radius: 4px;
          background-color: #f8fafc;
        }
      `}</style>
    </div>
  );
};

export default ViewFeedback;